import { useState, type FormEvent } from 'react'

interface Props {
  companyName: string
  open: boolean
  busy: boolean
  onClose: () => void
  onConfirm: (confirmName: string) => void
}

export default function AdminCompanyDeleteDialog({
  companyName, open, busy, onClose, onConfirm,
}: Props) {
  const [confirmText, setConfirmText] = useState('')
  const canDelete = confirmText.trim() === companyName

  if (!open) return null

  function handleSubmit(e: FormEvent) {
    e.preventDefault()
    if (!canDelete || busy) return
    onConfirm(confirmText.trim())
  }

  return (
    <div
      role="dialog"
      aria-modal="true"
      data-testid="admin-delete-company-dialog"
      className="admin-dialog-backdrop"
      onClick={onClose}
    >
      <form className="admin-dialog-card" onSubmit={handleSubmit} onClick={(e) => e.stopPropagation()}>
        <h2>Delete company</h2>
        <p>
          Soft-deletes <strong>{companyName}</strong> and its users. This cannot be undone from the UI.
        </p>
        <label htmlFor="admin-delete-confirm-input">
          Type the company name to confirm:
        </label>
        <input
          id="admin-delete-confirm-input"
          data-testid="admin-delete-confirm-input"
          value={confirmText}
          onChange={(e) => setConfirmText(e.target.value)}
          placeholder={companyName}
          autoComplete="off"
        />
        <div className="admin-dialog-actions">
          <button type="button" className="btn b-ol" onClick={onClose} disabled={busy}>Cancel</button>
          <button
            type="submit"
            className="btn danger"
            disabled={!canDelete || busy}
            data-testid="admin-delete-confirm"
          >
            {busy ? 'Deleting…' : 'Delete company'}
          </button>
        </div>
      </form>
    </div>
  )
}
